import {Box} from '@mui/system'

const TabPanel = ({children, value, index, ...other}) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}>
            {value === index && <Box style={{height: '100%'}}>{children}</Box>}
        </div>
    )
}

export default TabPanel
